



































import { Component, Vue } from "vue-property-decorator";
import { RouteConfig } from "vue-router";

import { User } from "@/core/auth.interfaces";
import { inNavRoutes, routes } from "@/router";
import { authSignOut } from "@/store/types";

/**
 * Main app navigation route links
 */
@Component
export default class Nav extends Vue {
  links = inNavRoutes(routes);

  get user(): User {
    return this.$store.state.user;
  }

  signOut() {
    this.$store.dispatch(authSignOut);
  }
}
